import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Navbar from 'reactstrap/lib/Navbar';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { LogoSection } from './logo-section';
import { SearchBox } from './search-box';
import { NavigationLinks } from './navigation-links';
import { InsiderSection } from './insider-section';

export const XL_BREAKPOINT = 1200;

// Navigation for tablets, laptops and desktop

export function GlobalNavigationDesktop({ showSearchBar, pathname, isAppraisalLinkExcluded, renderLogo }) {
  return (
    <Navbar
      className="global-navigation-desktop d-flex flex-wrap flex-sm-nowrap flex-row align-items-center justify-content-between"
      aria-label="Main Navigation"
    >
      <div
        className={classnames(
          'd-flex align-items-center w-sm-auto w-100 justify-content-center flex-column flex-sm-row flex-md-row',
          {
            'flex-basis-100': showSearchBar,
          }
        )}
        style={showSearchBar ? { flexBasis: '100%' } : null}
      >
        <LogoSection renderLogo={renderLogo} />

        {showSearchBar && <SearchBox isMobile={false} />}
      </div>

      <div className="navigation-links-col">
        <NavigationLinks
          className="d-flex flex-row justify-content-around justify-content-md-center align-items-center"
          pathname={pathname}
          renderAppraisalLink={!isAppraisalLinkExcluded}
        />
      </div>

      <FeatureFlag name="insider">
        <div className="d-flex align-items-center flex-no-shrink">
          <InsiderSection className="d-flex flex-row flex-nowrap justify-content-end ms-auto" isGlobalNavDesktop />
        </div>
      </FeatureFlag>
    </Navbar>
  );
}

GlobalNavigationDesktop.propTypes = {
  pathname: PropTypes.string,
  showSearchBar: PropTypes.bool,
  isAppraisalLinkExcluded: PropTypes.bool,
  renderLogo: PropTypes.func,
};

GlobalNavigationDesktop.defaultProps = {
  pathname: '',
  showSearchBar: true,
  isAppraisalLinkExcluded: false,
  renderLogo: undefined,
};
